import CompanyDashboard from "@/pages/CompanyDashboard";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/dashboard")({
  component: CompanyDashboard,
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  validateSearch: zodValidator(
    z.object({
      from: z.string().optional(),
    }),
  ),
  loader: ({params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, params.companyId);
  },
});
